import hash from 'object-hash';

const getHash = (object: unknown) => (object ? hash(object) : '');

export const KEYS = {
  catalog: {
    solutionTopics: {
      list: () => `catalog-solution-topics-list`,
      getById: (id: number) => `catalog-solution-topics-getById-${id}`
    },
    areaManager: {
      list: () => `catalog-area-manager-list`,
      getAllAreaManager: () => `catalog-area-manager-get-All-Area`
    },
    generatedReport: {
      list: () => `catalog-generated-report-list`,
      getGeneratedReportStatus: () => `catalog-get-Generated-Report-Status`,
      getGeneratedReportTypes: () => `catalog-get-Generated-Report-Types`
    },
    invoiceTags: {
      list: () => `catalog-invoiceTags-list`,
      getAllInvoiceTags: () => `get-all-catalog-invoiceTags`
    },
    invoiceFuel: {
      list: () => `catalog-invoiceFuel-list`,
      getAllInvoiceFuel: () => `get-all-catalog-invoiceFuel`
    },
    invoiceExpense: {
      list: () => `catalog-invoice-Expense-list`,
      getAllInvoiceExpense: () => `get-all-catalog-invoice-Expense`
    },
    partners: {
      getAllPartners: () => `catalog-partners-get-All-Partners`,
      getPartnersByUserId: () => `catalog-partners-get-partners-by-user-id`
    },
    responsibleType: {
      list: () => `catalog-responsible-type-list`
    },
    area: {
      list: () => `catalog-area-list`,
      getAllArea: () => `catalog-area-get-All-Area`
    },
    ticketDelayClassification: {
      list: () => `catalog-Ticket-Delay-Classification-list`,
      getAllTicketDelayClassification: () =>
        `catalog-area-get-All-Ticket-Delay-Classification`
    },
    impact: {
      list: () => `catalog-impact-list`,
      getAllImpact: () => `catalog-impact-get-All-Impact`
    },
    urgency: {
      list: () => `catalog-urgency-list`,
      getAllUrgency: () => `catalog-urgency-get-All-Urgency`
    },
    priority: {
      list: () => `catalog-priority-list`,
      getAllPriority: () => `catalog-priority-get-All-Priority`
    },
    criticality: {
      list: () => `catalog-criticality-list`,
      getAllCriticality: () => `catalog-criticality-get-All-Criticality`,
      getPriorityByUrgencyAndImpact: () => 'get-Priority-ByUrgency-And-Impact'
    },
    statusCongurationComponents: {
      list: () => `catalog-status-configuration-components-list`,
      getAllStatusCongigurationComponents: () =>
        `catalog-get-All-status-configuration-components`
    },
    cancelationReason: {
      getAll: () => `catalog-cancelation-reason-getAll`,
      getAllByFirstCondition: () =>
        `catalog-cancelation-reason-getAllByFirstCondition`
    },
    currencies: {
      list: () => `catalog-currencies-list`,
      getAllCurrencies: () => `get-all-catalog-currencies`,
      detail: (id?: number) => `catalog-currencies-detail-${id}`
    },
    productStatus: {
      list: () => `catalog-productStatus-list`,
      getAllProductStatus: () => `get-all-catalog-product-Status`,
      getProductMovementStatus: () => `get-product-movement-status`
    },
    productCondition: {
      list: () => `catalog-productCondition-list`,
      searchProductCondition: () =>
        `catalog-productCondition-SearchProductCondition`,
      getAllProductConditions: () => `catalog-get-all-productCondition`
    },
    brands: {
      getAllBrands: () => `catalog-Get-All-Brands`,
      list: () => `catalog-brands-list`,
      deleteBrand: (id?: number) => `catalog-Delete-Brand-${id}`,
      getModelsByBrandId: (id?: number) =>
        `catalog-Get-Models-By-BrandId-${id}`,
      getBrandsByClientId: (id?: number) =>
        `catalog-Get-Brands-By-ClientId-${id}`
    },
    frequentFailure: {
      jobCategoryIdDetail: (id?: number) =>
        `catalog-frequentFailure-jobCategoryIdDetail-${id}`,
      getFrequentFailures: () => `catalog-frequentFailure-getFrequentFailures`,
      deleteFrequentFailure: () =>
        `catalog-frequentFailure-deleteFrequentFailure`,
      editFrequentFailure: () => `catalog-frequentFailure-editFrequentFailure`,
      createFrequentFailure: () =>
        `catalog-frequentFailure-CreateFrequentFailure`
    },
    equipmentType: {
      generalSearch: () => `catalog-equipmentTypes-general-search`,
      list: () => `catalog-equipmentTypes-list`
    },
    reparationType: {
      generalSearch: () => `catalog-reparation-Types-general-search`,
      list: () => `catalog-reparation-Types-list`,
      getReparationTypesByModelId: () =>
        `catalog-reparation-Types-get-Reparation-Types-By-Model-Id`
    },
    jobSubCategories: {
      jobCategoryIdDetail: (id?: number) =>
        `catalog-jobSubCategory-jobSubCategoryIdDetail-${id}`,
      getJobSubCategory: () => `catalog-jobSubCategory-getJobSubCategory`,
      deleteJobSubCategory: () => `catalog-jobSubCategory-deleteJobSubCategory`,
      createJobSubCategory: () => `catalog-jobSubCategory-createJobSubCategory`
    },
    serviceTypes: {
      list: () => `catalog-serviceTypes-list`,
      getAll: () => `get-all-catalog-serviceTypes`,
      detail: (id?: number) => `catalog-serviceTypes-detail-${id}`,
      getServiceTypes: () => `catalog-getServiceTypes`,
      getServiceTypesByClient: () =>
        `catalog-getServiceTypes-GetServiceTypesByClient`,
      saveSurveyOfServiceType: (data: string) =>
        `catalog-Save-Survey-Of-ServiceType-${data}`
    },
    serviceTypesClosingFields: {
      getServiceTypesClosingFieldsById: () =>
        `get-all-catalog-Service-Types-Closing-Fields-By-Id`
    },
    priorities: {
      getAllPriorities: () => `get-all-catalog-getPriorities`,
      getPriorities: () => `catalog-getPriorities`
    },
    models: {
      getModels: () => `catalog-getModels`
    },
    paymentTypes: {
      list: () => `catalog-paymentTypes-list`,
      detail: (id?: number) => `catalog-paymentTypes-detail-${id}`
    },
    reasons: {
      list: () => `catalog-reasons-list`,
      detail: (id?: number) => `catalog-reasons-detail-${id}`,
      getByReasonTypeDetail: (reasonType: number) =>
        `catalog-reasons-getByReasonTypeDetail-${reasonType}`,
      getReasonsByFilter: (reasonType?: number) =>
        `catalog-reasons-getReasonsByFilter-${reasonType || ''}`,
      createReason: () => `catalog-reasons-createReason`,
      editReason: (reasonId: number) =>
        `catalog-reasons-editReason-${reasonId}`,
      removeReason: (reasonId: number) =>
        `catalog-reasons-removeReason-${reasonId}`
    },
    reasonsTypes: {
      getAll: () => `catalog-reasonsTypes-getAll`,
      getByFilter: () => `catalog-reasons-reasonsTypes-`,
      create: () => `catalog-reasonsTypes-create`,
      update: (id: number) => `catalog-reasonsTypes-update-${id}`,
      delete: (id: number) => `catalog-reasonsTypes-delete-${id}`
    },
    taskForces: {
      list: () => `catalog-taskForces-list`
    },
    inventory: {
      getCouriers: () => `catalog-inventory-getCouriers`,
      getShipmentPriority: () => `catalog-inventory-getShipmentPriority`,
      getAllResponsibleType: () => `catalog-inventory-getAllResponsibleType`,
      getResponsibleTypeById: (id: number) =>
        `catalog-inventory-getResponsibleTypeById-${id}`,
      getShipmentState: () => `catalog-ShipmentState`
    },
    operationTypes: {
      operationType: () => `config-components-for-service-types`
    },
    ticketCommentTypes: {
      getAllCommentTypes: () => `catalog-ticketCommentTypes-getAllCommentTypes`,
      getCommentTypesDetail: (commentTypeId: number) =>
        `catalog-ticketCommentTypes-commentTypeById-${commentTypeId}`,
      getCommentTypesByFilter: () =>
        `catalog-ticketCommentTypes-getCommentTypesByFilter`,
      createCommentType: () => `catalog-ticketCommentTypes-createCommentType`,
      editCommentTypes: (commentTypeId: number) =>
        `catalog-ticketCommentTypes-editReason-${commentTypeId}`,
      removeCommentTypes: (commentTypeId: number) =>
        `catalog-ticketCommentTypes-removeReason-${commentTypeId}`
    },
    site: {
      getAll: () => `get-all-catalog-site`,
      getSiteDetail: (siteId: number) => `catalog-site-siteById-${siteId}`,
      searchSite: () => `catalog-site-searchSite`,
      createSite: () => `catalog-site-createSite`,
      editSite: (siteId: number) => `catalog-site-editSite-${siteId}`,
      removeSite: (siteId: number) => `catalog-site-removeSite-${siteId}`
    },
    project: {
      AllProjects: () => `catalog-project-all-Projects`
    },
    workFlowType: {
      searchWorkFlowTypes: () => `catalog-workFlowType-SearchWorkFlowTypes`,
      getAllWorkFlowTypes: () =>
        `get-all-catalog-workFlowType-SearchWorkFlowTypes`
    },
    workFlowOrderStates: {
      getAll: () => `catalog-workFlowOrderStates-getAll`
    },
    status: {
      getAllStatus: () => `status-get-all-status`,
      getAllStatusesByClient: () => `status-get-all-statuses-by-client`
    },
    unitOfMeasure: {
      getAllUnitOfMeasure: () => `catalog-unitOfMeasure-getAllUnitOfMeasure`
    },
    CancellationReason: {
      getAllCancellationReason: (params: number) =>
        `catalog-interventionCodes-get-All-Cancellation-Reason-${params}`,
      getAllCancellationReasonById: (id: number) =>
        `catalog-interventionCodes-get-All-Cancellation-Reason-By-Id-${id}`
    },
    category: {
      getAllCategory: (params: number) => `catalog-All-Category-${params}`,
      getAllCategoryById: (id: number) => `catalog-All-Category-By-Id-${id}`,
      getAllCategoryActive: () => `get-All-Category`,
      getAllSubCategory: (id: number) => `get-All-Sub-Category-${id}`
    },
    PendingForSerialReason: {
      getAllPendingForSerialReason: (params: number) =>
        `catalog-interventionCodes-get-All-Pending-For-Serial-Reason-${params}`,
      getAllIpendingForSerialReasonById: (id: number) =>
        `catalog-interventionCodes-get-All-Pending-For-Serial-Reason-By-Id-${id}`
    },
    ReasonPendingForReason: {
      getAllReasonPendingForReason: (params: number) =>
        `catalog-interventionCodes-get-All-Reason-Pending-For-Reason-${params}`,
      getAllIReasonPendingForReasonById: (id: number) =>
        `catalog-interventionCodes-get-All-Reason-Pending-For-Reason-By-Id-${id}`
    },
    interventionCodes: {
      getAllInterventionCodesLevels: (params: number) =>
        `catalog-interventionCodes-get-All-Intervention-Codes-Levels-${params}`,
      getAllInterventionsCodesById: (id: number) =>
        `catalog-interventionCodes-get-AllInterventions-Codes-By-Id-${id}`
    },
    reasonSchedueled: {
      getAllReasonSchedueled: (params?: number) =>
        `catalog-reason-Scheduele-get-All-Reason-Schedueled-${params}`
    },
    irreparableReason: {
      getAll: () => `catalog-irreparableReason-get-All`
    },
    languages: {
      getAllLanguages: () => `catalog-language-get-All`
    },
    audit: {
      getAll: () => `catalog-audit-get-All`,
      getAuditGeneralSearch: () => `get-audit-general-search`
    },
    wareHouseType: {
      getAll: () => `catalog-wareHouseType-get-All`
    },
    notificationPriority: {
      getAll: () => `catalog-notificationPriority-get-All`
    },
    notificationType: {
      getAll: () => `catalog-notificationType-get-All`
    },
    reportCatalogue: {
      getAll: () => `catalog-reportCatalogue-get-All`
    },
    Forms: {
      getAllFieldsCostum: (id: number) => `get-all-fields-costum-${id}`,
      getFormCustom: () => `catalog-get-form-custom`,
      putFormCustom: (id: number) => `put-form-custom-${id}`,
      patchFormCustom: (id: number) => `patch-form-custom-${id}`,
      getAllTypeItemsCostum: (TypeItemsCostum: string) =>
        `get-all-type-items-costum-${TypeItemsCostum}`,
      deleteItemFormCustom: (id: number) => `delete-item-form-custom-${id}`
    },
    ticketStatusCategory: {
      getAll: () => `catalog-ticketStatusCategory-get-All`
    },
    serviceClass: {
      getAll: () => `catalog-service-Class-get-All`,
      getGeneralSearch: () => `catalog-service-Class-get-General-Search`,
      generalSearchInTickets: (id?: number) =>
        `catalog-service-Class-general-Search-In-Tickets-${id}`
    },
    towerModel: {
      generalSearch: () => `catalog-towerModel-general-search`,
      getAll: () => `catalog-towerModel-get-All`
    },
    towerType: {
      generalSearch: () => `catalog-towerType-general-search`,
      getAll: () => `catalog-towerType-get-All`
    },
    towerProperty: {
      generalSearch: () => `catalog-towerProperty-general-search`,
      getAll: () => `catalog-towerProperty-get-All`
    },
    changeService: {
      getAll: () => `catalog-change-service-get-All`
    },
    changeType: {
      getAll: () => `catalog-change-get-All`,
      getById: (id: number) => `catalog-change-get-ById-${id}`,
      getStageById: (id: number) => `catalog-get-stage-by-id-${id}`
    },
    changeStageAndStatus: {
      paginatedStages: () => `catalog-change-get-paginated-stages`,
      paginatedStatus: (id: number) =>
        `catalog-change-get-paginated-status-${id}`,
      getAll: () => `catalog-change-get-all`
    },
    taskStatus: {
      getAllTaskStatus: () => `catalog-task-Status-get-All`
    },
    taskType: {
      getAllTaskType: () => `catalog-Task-Type-get-All`
    }
  },
  client: {
    clients: {
      list: () => `client-clients-list`,
      getAllEnabledClients: () => `client-all-enabled-clients`,
      detail: (id?: number) => `client-clients-detail-${id}`,
      jobCategoriesDetail: (id?: number) =>
        `client-clients-jobCategoriesDetail-${id}`,
      jobCategoriesJubSubCategoriesDetail: (
        id?: number,
        clientJobCategoryId?: number
      ) =>
        `client-clients-jobCategoriesJubSubCategoriesDetail-${id}-${clientJobCategoryId}`,
      locationDetail: (id?: number | string, locationName?: string) =>
        `client-clients-locationDetail-${id}-${locationName}`,
      locationsDetail: (id?: number) => `client-clients-locationsDetail-${id}`,
      projectsDetail: (id?: number, serviceTypeID?: number) =>
        `client-clients-projectsDetail-${id}-${serviceTypeID}`,
      getAllClient: () => `client-clients-clients.getAllClient`,
      getClientById: () => `client-clients-clients.getClientById`,
      getClientClassificationByClient: () =>
        `client-clients-clients.getClientClassificationByClient`,
      getClientServiceTypesByClient: (id?: number) =>
        `client-clients-clients.getClientServiceTypesByClient-${id}`,
      getActiveStatusesByClient: () =>
        `client-clients-getActiveStatusesByClient`,
      getFinishedStatusesByClient: () =>
        `client-clients-getFinishedStatusesByClient`
    },
    services: {
      serviceConfigs: (id: number) => `client-service-serviceConfigs-${id}`,
      serviceConfigsSchudelHtAtt: () =>
        `client-service-service-configs-schudel-ht-att`,
      followFlags: () => `cleint-service-follow-flags`,
      serviceSearch: () => `client-service-serviceSearch`,
      getServiceById: (id: number) => `client-service-getServiceById-${id}`,
      getServiceDetail: (id?: number | string) => `client-Service-detail-${id}`,
      generalClientServiceSearch: (id?: number) =>
        `general-Client-Service-Search-${id}`,
      getServiceResponseTime: (id?: number) =>
        `client-get-Service-Response-Time-${id}`,
      getServiceConfig: (id?: number) => `client-get-Service-Config-${id}`,
      getLimitingValuesService: (id?: number) =>
        `client-get-Service-Config-limit-values-${id}`,
      getRelatedService: (id?: number) => `client-get-Related-Service-${id}`,
      configureServiceAutomaticClose: () =>
        `client-get-Service-Config-automatic-close`,
      configureServiceProduct: () =>
        `client-get-Service-Config-service-product`,
      configureServiceMaximumIncidents: () =>
        `client-get-Service-Config-Maximum-Incidents`,
      configureServiceProductAndAutomaticClose: () =>
        `client-get-Service-Config-service-product-automatic-close`,
      configureServiceInterventionCode: () =>
        `client-get-Service-Config-service-Intervention-Code`
    },
    project: {
      getProjects: () => `client-Projects`
    },
    responsables: {
      getResponsibleByResponsibleType: () =>
        `get-Responsible-By-ResponsibleType`,
      getResponsibleByResponsibleTypeOne: () =>
        `get-Responsible-By-ResponsibleType-One`,
      GetAllEnginersForAPostCode: () => `get-all-Enginners-for-an-assignation`,
      getAllResponsablesByResponsibleType: (id?: number) =>
        `get-all-Responsables-by-ResponsibleType-${id}`,
      getWarehouseResponsible: () => `get-Warehouse-Responsible`,
      getResponsables: () => `get-all-Responsables`
    },
    countryStates: {
      getCountryStatesByClient: (clientId?: number) =>
        `Get-Country-States-By-Client-${clientId}`
    },
    serviceTypes: {
      getServiceTypes: () => `client-getServiceTypes`
    },
    workFlowStages: {
      searchWorkFlowStages: () => `catalog-workFlowType-SearchWorkFlowStages`,
      searchWorkFlowStagesPredecesor: () =>
        `catalog-workFlowType-SearchWorkFlowStages-Predecesor`
    },
    workFlows: {
      getWorkFlowsByClient: (id: number) =>
        `Get-Work-Flows-By-Client-Id(${id})}`,
      getWorkFlowsByWorkFlowTypeId: (id: number | string) =>
        `client-workFlows-getWorkFlowsByWorkFlowTypeId-${id}`
    },
    ticketFlow: {
      getAll: () => `get-all-Ticket-Flow`,
      getTicketFlowByID: (id: number) => `Get-Ticket-Flow-By-Id(${id})}`,
      getGanttDiagram: () => `client-get-Gantt-Diagram`
    },
    serviceConfigurations: {
      getServiceConfigurations: () => `client-get-Service-Configurations`,
      getServiceConfigurationsByClient: (id?: number) =>
        `client-get-Service-Configurations-By-Client-Id-${id}`,
      getServiceEvidences: (serviceIdd: number) =>
        `client-get-Service-Evidences-${serviceIdd}`,
      configureServiceFlowStates: () => `client-configure-Service-Flow-States`
    },
    workFlowOrder: {
      generalSearch: () => `client-workFlowOrder-generalSearch`,
      findByID: (id: string) => `client-workFlowOrder-findByID-${id}`,
      getCommentsByID: (id: number) =>
        `client-workFlowOrder-get-comments-by-id-${id}`,
      getFilesByID: (id: number) =>
        `client-workFlowOrder-get-files-by-id-${id}`,
      searchWorkFlowOrderByLocationId: () =>
        `client-workFlowOrder-search-Work-Flow-Order-By-Location-Id`,
      getGanttModal: () => `client-workFlowOrder-get-Gantt-Modal`
    },
    operationServices: {
      getOperationServices: () => `client-get-Operation-Services`
    },
    waterMark: {
      getWaterMark: () => `client-get-Water-Mark`
    }
  },
  geography: {
    workZones: {
      getGlobalWorkZones: () => `get-Global-WorkZones`,
      getTimeZones: () => `get-Time-Zones`,
      getRegions: () => `get-Regions-Active`,
      getGlobalStatesByCityId: (data?: number) =>
        `get-Global-States-By-City-Id-${data}`,
      getGlobalRegionsByCityId: (data?: number) =>
        `get-Global-Regions-By-City-Id-${data}`,
      getMunicipalitiesById: () => `get-Municipalities-By-Id`,
      getGlobalCodePostByMunicId: (id?: number) =>
        `get-Global-Municipalities-By-Id-${id}`
    },
    locations: {
      getLocations: () => `get-locations`,
      getClusteredLocations: () => `get-clustered-locations`
    },
    locationZones: {
      getLocationZones: () => `get-locationZones`
    },
    localities: {
      getLocalitiesByPostalCode: (postalCode: string | number) =>
        `get-localities-${postalCode}`
    },
    locationsLog: {
      getLocationsLog: () => `get-locations-Log`
    },
    states: {
      getStates: () => `get-states`,
      getMunicipalitiesByState: (stateId: number) =>
        `get-municipalities-by-state-${stateId}`,
      getStatesByRegion: (regionId: number) =>
        `get-states-by-region-${regionId}`,
      getStatesById: (id?: number) => `get-states-by-id-${id}`
    },
    postalCodes: {
      getPostalCodesByClient: (clientId: string) =>
        `get-postal-codes-by-client-${clientId}`,
      getGeneralSearchPostalCodes: () => `get-general-search-postal-codes`
    },
    regions: {
      getRegions: () => `get-regions`,
      getRegionsByStatesIds: (stateIds: string) =>
        `get-regions-by-states-${stateIds}`
    },
    holidays: {
      getHolidaysByCountry: (countryId: number) =>
        `get-holidays-by-country-${countryId}`,
      createHolidaysByCountry: () => `create-holidays-by-country`
    },
    tower: {
      getTowers: () => `get-towers`,
      generalSearch: () => `tower-general-search`,
      getTowerByLocationId: () => `get-tower-by-location-id`
    },
    towersLog: {
      getTowersLog: () => `get-towers-log`
    }
  },
  inventory: {
    taskForce: {
      meSupplies: (id = '') => `inventory-taskForce-meSupplies-${id}`,
      meAccessoriesList: (id = '') =>
        `inventory-taskForce-meAccessoriesList-${id}`,
      getMeAccesoriesByProductID: () =>
        `inventory-taskForce-AccesoriesByProductID`,
      GetOriginTaskForcesByUser: () =>
        `inventory-taskForce-getOriginTaskForcesByUser`,
      GetDestinationTaskForcesByUser: () =>
        `inventory-taskForce-getDestinyTaskForces`,
      getMeAccesoriesTotalByLocId: () =>
        `inventory-taskForce-get-Me-Accesories-Total-By-Loc-Id`
    },
    warehouse: {
      GetDestinyWarehouses: () => `inventory-warehouse-getDestinyWarehousesOne`,
      GetDestinyTaskForcesById: (id: number) =>
        `inventory-taskForces-GetDestinyTaskForcesById-${id}`,
      GetDestinyWarehousesById: (id: number) =>
        `inventory-wareHouses-GetDestinyWarehousesById-${id}`,
      GetDestinationEnginnersById: (id: number) =>
        `inventory-warehouse-getDestinationEnginnersById-${id}`,
      GetDestinationWarehousesById: (id: number) =>
        `inventory-warehouse-getDestinationWarehousesById-${id}`,
      GetOriginWarehouseByUser: () => `inventory-warehouse-getOriginWarehouses`,
      GetDestinyWarehouseByUser: () =>
        `inventory-warehouse-getDestinyWarehouses`,
      getResponsibleIdByUser: (shipmentId?: number) =>
        `inventory-warehouse-getResponsibleIdByUser-${shipmentId}`,
      warehouseGeneralSearch: () => `inventory-warehouse-generalSearch`,
      getWarehousesComponentInventory: () => `get-warehouses-inventory`,
      getLaboratoryComponentInvetory: () => `get-laboratory-inventory`,
      getLaboratoryComponentInvetoryForReasignation: () =>
        `get-laboratory-inventory-For-Reasignation`,
      getLaboratoryComponentInvetoryForAceptation: () =>
        `get-laboratory-inventory-for-aceptation`,
      getWarehousesKITSInventory: () => `get-warehouses-Kit`,
      getDestinationEngineers: () =>
        `inventory-warehouse-getDestinationEngineers`,
      getDestinationWarehouses: () =>
        `inventory-warehouse-getDestinationWarehouses`,
      getWarehousesSupplyInventory: () => `get-warehouses-supply-inventory`
    },
    warehouseTypes: {
      getWarehouseTypes: () => `inventory-warehouseTypes-getWarehouseTypes`
    },
    shipmentConfigurationComponent: {
      getConfigurationComponentsItemsByUser: (
        inventoryDestinyWatcher?: number
      ) =>
        `inventory-shipmentConfigurationComponent-getConfigurationComponentsItemsByUser(${inventoryDestinyWatcher})`,
      getAllConfigurationComponentsByShipment: (id = '') =>
        `inventory-shipmentConfigurationComponent-getAllConfigurationComponentsByShipment-${id}`
    },
    shipment: {
      cancelShipment: (id = '') => `inventory-shipment-cancelShipment-${id}`,
      createShipment: () => `inventory-shipment-createShipment`,
      getShipmentById: (id: number) =>
        `inventory-shipment-getShipmentById-${id}`,
      receiptShipment: (id: number | string) =>
        `inventory-shipment-receiptShipment-${id}`,
      getPendingShipmentsByUser: () =>
        'inventory-shipment-getPendingShipmentsByUser',
      getShipments: () => 'inventory-shipment-getShipments',
      getInventoryShipments: () => 'inventory-shipment-getInventoryShipments',
      shipmentStatusTracking: (shipmentId: number) =>
        `inventory-shipment-shipmentStatusTracking-${shipmentId}`
    },
    supplies: {
      getAllSupplies: () => `inventory-supplies-get-All-Supplies`,
      getAllSuppliesWhitPagination: (params?: unknown) =>
        `inventory-supplies-get-All-Supplies-Whit-Pagination-${
          params as string
        }`
    },
    inventories: {
      getWorkForcesComponentInventory: () =>
        'inventory-WorkForces-GetWorkForcesComponentInventory',
      getWorkForcesSupplyInventory: () =>
        'inventory-WorkForces-getWorkForcesSupplyInventory',
      getWorkForcesKitsInventory: () =>
        'inventory-WorkForces-GetWorkForcesKitsInventory',
      getLocationsComponentInventory: () =>
        'inventory-WorkForces-GetLocationsComponentInventory',
      getShipmentsByWorkForce: () => 'inventory-WorkForces-GetShipments'
    }
  },
  product: {
    supplies: {
      listSupplies: (serviceId?: number) => `supplies-list-${serviceId}`,
      GetSuppliesForShipment: (id: string | number = '') =>
        `get-supplies-for-shipment-list-${id}`
    },
    tickets: {
      getTicketsByProductId: (id: string | number = '') =>
        `get-ticket-by-product-id:${id}`,
      getTicketComponentsByTicketId: () => `get-ticket-components-by-ticket-id`
    },
    products: {
      GetProductsForShipment: () => `get-products-for-shipment-list`,
      KitsForShipment: () => `get-kits-for-shipment-list`,
      list: (id: string | number = '') => `produxt-products-list-${id}`,
      getForTicketAsignationList: (id: string | number = '') =>
        `produxt-products-getForTicketAsignationList-${id}`,
      getAllForTicketAsignationByClientIdDetail: (id: string | number = '') =>
        `produxt-products-getAllForTicketAsignationByClientIdDetail-${id}`,
      getAllForTicketAsignationByLocationIdDetail: (id: string | number = '') =>
        `produxt-products-getAllForTicketAsignationByLocationIdDetail-${id}`,
      getAllForAsignationByClientAndUserId: () =>
        `produxt-products-getAllForAsignationByClientAndUserId`,
      detail: (id: string | number = '') => `produxt-products-detail-${id}`,
      getGeoLocationOfConfigComponents: (id: string | number = '') =>
        `produxt-products-getGeoLocationOfConfigComponents-${id}`,
      getLogbookConfig: (id: string | number = '') =>
        `config-component-logbook-get-logbook-config-${id}`,
      getLogbookConfigExport: (id: string | number = '') =>
        `config-component-logbook-get-logbook-config-Export-${id}`,
      getAllConfigComponent: () => 'produxt-products-get-All-Config-Component',
      productHealthCheck: () => `product-Health-Check`,
      GetForProblems: () => `product-products-get-For-Problems`
    },
    configurationComponents: {
      getShipmentTracking: `products-configurationComponents-getShipmentTracking`
    },
    kits: {
      generalSearchKits: (params?: number) =>
        `products-kits-general-Search-Kits=${params}`,
      getConfigCompoByKitId: (id?: number) =>
        `products-kits-get-Config-Compo-By-KitId-${id}`,
      getKitLoogBookById: (id?: number) =>
        `products-kits-get-Kit-Loog-Book-By-Id-${id}`,
      getKitStatus: () => `products-kits-get-Kit-Status`
    },
    audit: {
      supppliesGeneralSearch: () => `supplies-general-search`,
      auditReportGeneralSearch: () => `audit-report-general-search`
    }
  },
  ticket: {
    assignations: {
      getAssignableTaskForceByClientIdDetail: (clientId?: number) =>
        `ticket-assignations-getAssignableTaskForceByClientIdDetail-${clientId}`,
      getAssignableTaskForceByTicketsId: (ticketId?: string[]) =>
        `ticket-assignations-getAssignableTaskForceByTicketsId-${ticketId.join(
          '-'
        )}`,
      getAssignableTaskForceByTicketsIdCreate: (id = '') =>
        `ticket-assignations-getAssignableTaskForceByTicketsIdCreate-${id}`,
      assignTaskForceToTicketsCreate: (id = '') =>
        `ticket-assignations-assignTaskForceToTicketsCreate-${id}`,
      reAssignTaskForceToTicketsCreate: (id = '') =>
        `ticket-assignations-reAssignTaskForceToTicketsCreate-${id}`
    },
    expenseReport: {
      GetExpenseReport: () => `ticket-expense-report-get-Expense-Report`
    },
    mayorIncident: {
      GetMayorIncident: () => `ticket-mayor-incident`
    },
    remoteWorkReport: {
      getRemoteWorkReport: () => `ticket-remote-work-report`
    },
    taskForce: {
      meAcceptAssignationsCreate: (id = '') =>
        `ticket-taskForce-meAcceptAssignationsCreate-${id}`,
      meRejectAssignationsCreate: (id = '') =>
        `ticket-taskForce-meRejectAssignationsCreate-${id}`,
      meUpdateTicketsToTravelStatusCreate: (id = '') =>
        `ticket-taskForce-meUpdateTicketsToTravelStatusCreate-${id}`,
      meUpdateTicketsToOnSiteStatusCreate: (id = '') =>
        `ticket-taskForce-meUpdateTicketsToOnSiteStatusCreate-${id}`,
      meUpdateTicketsToClosedStatusCreate: (id = '') =>
        `ticket-taskForce-meUpdateTicketsToClosedStatusCreate-${id}`,
      meSearchMyTicktes: (id = '') =>
        `ticket-taskForce-meSearchMyTicktes-${getHash(id)}`,
      getMeAccesoriesByID: (id?: number) =>
        `ticket-taskForce-getMeAccesoriesByID-${id}`,
      getMeSuppliesByID: (id?: number) =>
        `ticket-taskForce-getMeSuppliesByID-${id}`,
      getGeolocations: () => `ticket-taskForce-getGeolocations`
    },
    tickets: {
      create: (id = '') => `ticket-tickets-create-${id}`,
      generalSearch: (id: string[] = []) =>
        `ticket-tickets-generalSearch-${id.join('-')}`,
      detail: (id?: number) =>
        id ? `ticket-tickets-detail-${id}` : `ticket-tickets-detail`,
      multipleTicketSearch: (id: string[] = []) =>
        `ticket-tickets-multipleTicketSearch-${id.join('-')}`,
      getServiceTicketsByUbication: (id: string | number) =>
        `ticket-tickets-getServiceTicketsByUbication-${id}`,
      getCitronellaTicketsByUbication: (id: string | number) =>
        `ticket-tickets-getCitronellaTicketsByUbication-${id}`,
      getAvailableStatuses: () => `ticket-tickets-getAvailableStatuses`,
      getTicketsToReasign: () => `ticket-tickets-getTicketsToReasign`,
      getTicketsHistoryByLocationId: (id?: number) =>
        `get-Tickets-History-By-LocationId-${id}`,
      getTicketsRelatedByTicketId: (id: number) =>
        `get-Tickets-Related-By-TicketId-${id}`,
      confirmTicketClosed: () => `ticket-tickets-confirmTicketClosed`,
      updateDelayTicket: (id: number) => `update-DelayTicket-${id}`,
      getTicketReportConfigs: (id: number) =>
        `ticket-tickets-getTicketReportConfigs-${id}`,
      GetProblemTickets: (key?: string | number) =>
        `GetProblemTickets-${key || ''}`
    },
    comment: {
      list: () => `tickets-coments-list`,
      listxTicket: (id?: number) => `ticket-comment-listxTicket-${id}`,
      listClosexTicket: (id?: number) =>
        `ticket-comment-listClosexTicket-${id}`,
      getCommenTypes: () => `ticket-comment-get-commet-types`
    },
    dashboard: {
      getAssignment: () => `dashboard-get-assignment`,
      upToDate: () => `dashboard-get-uptodate-tickets`,
      getByStatus: () => `dashboard-get-by-status-tickets`,
      getTicketsFirstCallStatistics: () => `dashboard-get-tickets-first-call`
    },
    logbook: {
      list: () => `tickets-log-book-list`
    },
    closedDetails: {
      getTicketClosedDetails: (id?: number | string) =>
        `ticket-closed-details-${id}`,
      list: () => `tickets-closed-details-list`
    },
    ticketEscalation: {
      getEscalationTypes: `tickets-ticketEscalation-getEscalationTypes`,
      getEscalations: `tickets-ticketEscalation-getEscalations`,
      getEscalationById: (id?: number) =>
        `tickets-ticketEscalation-getEscalationById-${id}`
    },
    serviceConfig: {
      getServiceEvidencesByTicket: (ticketId: number) =>
        `get-Service-Evidences-By-Ticket-${ticketId}`
    },
    tasksRelatedToTicket: {
      getTaskRelatedToTicketBYTaskId: (id?: number) =>
        `ticket-tasksRelatedToTicket-get-Task-Related-To-Ticket-BY-Task-Id-${id}`
    }
  },
  fileStorage: {
    getFileByChange: (id: number) => `getFileByChange-${id}`,
    getFilesByTicket: (data?: string) =>
      `fileStorage-files-getFilesByTicket-${data}`,
    getFileByTicektWhitPagination: (data?: string) =>
      `fileStorage-files-getFileByTicektWhitPagination-${data}`,
    getFilesByTower: () => `fileStorage-files-getFilesByTower`,
    tasks: {
      getFilesByTask: (data?: string) =>
        `fileStorage-files-getFilesByTask-${data}`
    },
    problems: {
      GetFilesByProblem: (id: number) => `GetFilesByProblem-${id}`,
      GetFilesByNote: (id: number) => `GetFilesByNote-${id}`
    },
    solutions: {
      GetSolutionsFilesById: (id: number) => `Get-Solutions-Files-By-Id-${id}`
    }
  },
  security: {
    getAllUsersByFilters: () => `security-users-get-All-Users-by-filters`,
    getAllUsers: () => `security-users-get-All-Users`,
    getAllUsersModuleTree: () => `security-users-get-All-Users-Module-Tree`,
    getUserById: (id?: number) => `security-users-get-User-By-ID(${id})`,
    GetDetailsUser: () => `security-users-Get-Details-User`,
    getAllRoles: () => `security-users-get-All-Roles`,
    getAllActiveRoles: () => `security-users-get-All-Active-Roles`,
    getGroupsGeneralSearch: () => `security-users-get-Groups-General-Search`,
    getSystemGroupAccessElementList: () =>
      `security-users-get-System-Group-Access-Element-List`,
    getSystemGroupByClientIdQuery: () => `get-System-Group-By-ClientId-Query`,
    getSystemGroupClientList: () => `get-System-Group-Client-List`,
    getSystemGroupById: () => `security-users-get-System-Group-By-Id`,
    getAllSystemGroups: () => `security-users-get-All-System-Groups`,
    getUsersBySystemGroup: () => `security-users-get-Users-By-System-Group`,
    getUsersWithSameRolesByUserId: () =>
      `security-get-Users-With-Same-Roles-By-User-Id`,
    getUserWarehouseList: (id?: number) =>
      `security-users-get-User-Warehouse-List(${id})`,
    getUserClientsList: (id?: number) =>
      `security-users-get-User-Clients-List(${id})`,
    getUsersDispatcherByTicket: () =>
      `security-users-get-Users-Dispatcher-By-Ticket`,
    getUserWorkForcesList: (id?: number, text?: string) =>
      `security-users-get-User-WorkForces-List(${id} ${text})`,
    getUserTicketCommentTypeList: (id?: number) =>
      `security-users-get-User-Ticket-Coment-Type-List(${id})`,
    getUserPermissionsGeneral: (id?: number) =>
      `security-users-get-User-Permissions-General-List(${id})`,
    getUserServicesList: (id?: number) =>
      `security-users-get-User-Services-List(${id})`,
    getUserPermitions: (id?: number) =>
      `security-users-get-User-Permitions-By-Id(${id})`,
    getOperatingPermission: (userId: number, partnerId: number) =>
      `security-users-get-Operating-Permission-${userId}-${partnerId}`,
    getAssignationList: () => `security-users-get-User-Assignation-List`,
    getWarehouseAdminUsers: () => `security-users-get-Warehouse-Admin-Users`,
    getAllActives: () => `security-users-get-All-Actives`,
    GetAccessList: () => `security-users-get-Access-List`,
    getClientsByUserID: () => `assignation-get-clients-by-user-id`,
    getAccessElementTracking: () =>
      `user-Assignations-get-Access-Element-Tracking`,
    canWarehouseAdminBeInactivate: () =>
      `security-users-can-Warehouse-Admin-Be-Inactivate`,
    getWorkForcesByUserId: {
      getWorkForcesByUserId: () => `assignation-get-workForces-by-user-id`
    },
    public: {
      getParams: () => `public-get-params`
    },
    generalParams: {
      getGeneralParams: () => `security-users-get-KBD`
    },
    getUserByClientId: (id?: number) =>
      `security-users-get-User-By-ClientId-${id}`,
    getUserChangeByClientId: {
      getUserChangeByClientId: (id?: number) =>
        `get-user-change-byClient-id-${id}`
    },
    getAllUserGroupByClientId: {
      getAllUserGroupByClientId: (id?: number) =>
        `get-all-user-group-ByClient-id-${id}`
    }
  },
  login: {
    AccessLoogbooks: (params?: string) => `login-Access-Loog-Books-${params}`
  },
  status: {
    getStatusPaginated: () => `status-get-status-paginated`
  },
  ticketFLow: {
    getTicketFlow: (id?: string) => `ticket-flow-get-ticket-flow-${id}`,
    getAllStatus: () => `ticket-flow-get-all-status`,
    getTicketFlowByStatus: (id?: number) =>
      `ticket-flow-get-ticket-flow-by-status-${id}`,
    generalSearch: `ticket-flow-general-search-admin`
  },
  messageCommunication: {
    notifications: {
      getUnread: `messageCommunication-notifications-getUnread`,
      getUnreadFromHttp: `messageCommunication-notifications-getUnread-from-http`,
      searchEscalations: `messageCommunication-notifications-searchEscalations`,
      getAllNotificationPaginated: `notifications-get-All-Notification-Paginated`,
      getAllNotificationsWhioutPagination: `notifications-get-All-Notifications-Whiout-Pagination`
    },
    location: {
      getMexicanPostalCode: `messageCommunication-locations-get-Mexican-Postal-Code`
    }
  },
  laboratories: {
    getLaboratoryTechnicians: `laboratories-get-laboratory-technicians`
  },

  recidivists: {
    getRecidivists: () => `recidivists-get-recidivists`,
    getRecidivistsByUbication: () => `recidivists-get-recidivists-by-ubication`
  },
  insight: {
    kpiGroup: {
      getAll: () => `insight-kpiGroup-get-all`,
      getKPIGroups: () => `insight-kpiGroup-get-KPI-Groups`,
      getKPIParameters: () => `insight-kpiGroup-get-KPI-Parameters`,
      getKPIFilters: () => `insight-kpiGroup-get-KPI-Filters`,
      getResults: () => `insight-kpiGroup-get-Results`
    },
    survey: {
      getTemplateById: (id: number) => `get-survey-template-by-id-${id}`,
      getAllActiveTemplate: (name: string) => `get-all-survey-template-${name}`,
      getAllTemplate: `get-all-survey-template`,
      getReports: `get-all-survey-reports`,
      getReportById: (id: number) => `get-survey-report-by-id-${id}`,
      getTemplateByIdTicket: (id: number) => `get-template-ByIdTicket-${id}`,
      getSurveyAnsweredById: (id: number) => `get-Survey-Answered-By-Id-${id}`,
      getSurveysAnsweredByTemplate: (id: number) =>
        `get-Surveys-Answered-By-Template-${id}`
    }
  },
  process: {
    ChangeAdvisoryBoard: {
      SearchChangeAdvisoryBoard: () => `Search-Change-Advisory-Board-CAB`,
      getById: (id: number) => `GET-by-ID-Change-Advisory-Board-CAB-${id}`,
      getAll: () => `changeAdvisoryBoard-getAll`
    },
    approvals: {
      SearchApprovals: () => `Search-Approvals-process`,
      ModalValidation: () => `ModalValidation-Approvals-process`
    },
    change: {
      searchChange: () => `process-change-search-Change`,
      getByChange: (id: number) => `process-get-by-change-${id}`
    },
    ChangeFlow: {
      getChangeFlow: (id: number) => `get-Change-Flow-${id}`,
      getStagesOfChangeFlow: (id: number) => `get-Stages-Of-Change-Flow-${id}`
    },
    solutions: {
      getSolution: () => `get-all-Solution`,
      getAllSolutionStatus: () => `get-all-Solution-Status`
    },
    problems: {
      search: () => `problem-search`,
      getById: (id: number) => `get-broblem-by-id-${id}`,
      getRelatedSolutions: (id: number) => `problems-getSolutionsRelated-${id}`,
      getRelatedRequests: (id: number) => `problems-getRelatedRequests-${id}`,
      getAnalysisSections: () => `problems-getAnalysisSections`,
      getNotes: (id: number) => `problems-getNotes-${id}`
    },
    ticketStatus: {
      getTicketStatus: () => `process-getTicketStatus`
    },
    task: {
      SearchTasksByProblemId: (id: number) => `Search-Tasks-By-ProblemId-${id}`,
      GetTaskCompletedByProblemId: (id: number) =>
        `Get-Task-Completed-By-ProblemId-${id}`
    }
  }
};
